import { PlayerColor } from '@colonist/game-states';
import { MechanicValidator } from './MechanicValidator.ts';
import { MechanicValidatorProgressCardsPlayer } from './MechanicValidatorProgressCardsPlayer.ts';
import { CardValidatorOrdered } from '../core/card/CardValidatorOrdered.ts';
export class MechanicValidatorProgressCards extends MechanicValidator {
    getProgressCardsPlayerValidator(player) {
        const progressCardsPlayerState = this.progressCardsPlayerValidators.get(player);
        if (progressCardsPlayerState == undefined) throw new Error(`No MechanicProgressCardsPlayerState for player ${player}`);
        return progressCardsPlayerState;
    }
    canPlayerUseAtLeastOneProgressCard(player) {
        for (const card of this.getProgressCardsPlayerValidator(player).progressCards.cards){
            if (!this.canPlayerUseProgressCard(player, card).canTakeAction) continue;
            return true;
        }
        return false;
    }
    canPlayerUseProgressCard(player, cardEnum) {
        const hasCard = this.getPlayersProgressCardCountForCard(player, cardEnum) > 0;
        return {
            canTakeAction: hasCard
        };
    }
    getPlayersTotalProgressCards(player) {
        const devCardsPlayerState = this.getProgressCardsPlayerValidator(player);
        return devCardsPlayerState.progressCards.cards.length;
    }
    getPlayersProgressCardCountForCard(player, cardEnum) {
        const progressCardsPlayerValidator = this.getProgressCardsPlayerValidator(player);
        return progressCardsPlayerValidator.progressCards.getCardCountForCard(cardEnum);
    }
    hasProgressCardsInPlayerHand(player, cardEnums) {
        const progressCardsPlayerValidator = this.getProgressCardsPlayerValidator(player);
        return progressCardsPlayerValidator.progressCards.hasCardsInInventory(cardEnums);
    }
    constructor(playerValidators, mapValidator, progressCardsState){
        super(playerValidators, mapValidator);
        this.bankProgressCards = new CardValidatorOrdered(progressCardsState.bankProgressCards);
        this.progressCardsPlayerValidators = new Map();
        for(const player in progressCardsState.players){
            const playerColor = Number(player);
            const progressCardsPlayerState = progressCardsState.players[playerColor];
            if (progressCardsPlayerState == undefined) continue;
            const progressCardsPlayerValidator = new MechanicValidatorProgressCardsPlayer(progressCardsPlayerState);
            this.progressCardsPlayerValidators.set(playerColor, progressCardsPlayerValidator);
        }
        const spectatorProgressCardsPlayerState = new MechanicValidatorProgressCardsPlayer({
            progressCards: {
                cards: []
            }
        });
        this.progressCardsPlayerValidators.set(PlayerColor.None, spectatorProgressCardsPlayerState);
    }
}
